export const clearSearch = (search: string): string => search.replace(/^\?/, '')
export const getCleanSearch = (): string => clearSearch(window.location.search)
